import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {CookieService} from "ngx-cookie-service";
import {UserService} from "../../Services/Users.service";
import {Configuration} from "../../config/config";
import {ActivatedRoute, Router} from "@angular/router";
import {GlobalService} from "../../Services/global.service";
import {formatNumber, isValidNumber, parse} from "libphonenumber-js";
import {TranslateService} from "@ngx-translate/core";
declare var $;

@Component({
  selector: 'app-isolated-new-user',
  templateUrl: './isolated-new-user.component.html',
  styleUrls: ['./isolated-new-user.component.css']
})
export class IsolatedNewUserComponent implements OnInit {

  @ViewChild('captchaCanvas') captchaCanvas: ElementRef;

  first_name: string;
  last_name: string;
  mail_id: string;
  phone: string;
  question:string;
  answer:string;
  password: string;
  re_password: string;
  user_name : string;
  country : string;
  organization : string;
  designation : string;
  validationMsg : string;
  show:boolean = true;
  contact : string = "";
  errorMsg :string = "";
  captcha : string;
  reCaptcha : string;
  privacyProtect:boolean = false;
  community_id : string = undefined;
  community_user : boolean = false;
  statusCode : string = '';
  countryCodeList : any;
  countryCode : string = undefined;
  countryId : string = undefined;
  isValidCommunity : boolean = false;
  privacyField:boolean = true;
  selectedOrganization: boolean= false;
  format: any;
  parse: any;
  community_list : Array<any> = [];
  securityQuestions : Array<any> = [];
  agreement;
  hideCommunity;
  // isDisabledComm : boolean = false;
  screenWidth: number = 1366;
  redirectUrl: string = '';
  communityLogoShow: boolean = false;
  community_name : string;

  globalCommRoleList : Array<any> = [];
  globalBUnitList : Array<any> = [];
  communityRoleList : Array<any> = [];
  businessUnitList : Array<any> = [];
  comm_role = undefined;
  business_unit = undefined;
  isDisableBUnit: boolean = false;
  isDisableCommRole: boolean = false;
  buttonTitle: any;
  passwordType: boolean = false;

  constructor(private userService: UserService,private router : Router, private globalService : GlobalService, private cookieService : CookieService, private route: ActivatedRoute, private translate: TranslateService) {
    this.countryCodeList = Configuration.countryCode;

    let lang_name = this.cookieService.get('defaultLang') ? this.cookieService.get('defaultLang') : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');
    this.translate.reloadLang(lang_name);
  }

  ngOnInit() {
    $("header").css('display','none');
    $("footer").css('display','none');
    $("body").addClass("isolatedBg");
    window.name = 'isolatedNewUserScreen';
    this.screenWidth = screen.width || window.screen.width;
    this.captcha = Math.random().toString(36).split('').filter( function(value, index, self) {
      return self.indexOf(value) === index;
    }).join('').substr(2,8);

    if(this.userService.isCommunity == undefined) {
      this.hideCommunity = true;
    }else {
      this.hideCommunity = false;
    }
    let lang_id = this.globalService.getLangId();
    this.userService.getSecurityQuestions(lang_id)
      .subscribe(questions =>{
        if(questions.success){
          this.securityQuestions = questions.data;
        }
      });

    $("#preloader").css('display','block');
    this.translate.get(['REGISTRATION.COMM_ROLE','REGISTRATION.SELECT_ROLE', 'REGISTRATION.NONE',
      'REGISTRATION.CREATEACCNTTEXT', 'REGISTRATION.GROUP', 'REGISTRATION.SELECT_GROUP', 'REGISTRATION.VALIDATION_MSG.REQUIRED_COMMUNITY',
      'REGISTRATION.ORG', 'REGISTRATION.BUSINESS_UNIT', 'REGISTRATION.SELECT_B_UNIT', 'REGISTRATION.VALIDATION_MSG.REQUIRED_BUSINESS_UNIT', 'REGISTRATION.USER_ID',
      'REGISTRATION.PLACEHOLDERS.USERNAME', 'REGISTRATION.USERNAME_NOTE', 'REGISTRATION.VALIDATION_MSG.REQUIRED_USERNAME', 'REGISTRATION.VALIDATION_MSG.INVALID_USERNAME',
      'REGISTRATION.EMAIL_ID', 'REGISTRATION.VALIDATION_MSG.REQUIRED_EMAILID', 'REGISTRATION.VALIDATION_MSG.INVALID_EMAILID', 'REGISTRATION.SECURITY_QUESTION',
      'SECURITY_QUESTION.DEFAULT_OPTION', 'REGISTRATION.VALIDATION_MSG.REQUIRED_SEC_QUE', 'BUTTON_TITLE.OK', 'REGISTRATION.COUNTRY_CODE', 'REGISTRATION.CLICK_HERE',
      'REGISTRATION.SEC_QUE_ANS', 'REGISTRATION.PLACEHOLDERS.ANSWER', 'REGISTRATION.VALIDATION_MSG.REQUIRED_ANSWER', 'REGISTRATION.VALIDATION_MSG.INVALID_ANSWER',
      'REGISTRATION.PASSWORD', 'REGISTRATION.PASSWORDTEXT', 'REGISTRATION.PASSWORD_NOTE', 'REGISTRATION.VALIDATION_MSG.REQUIRED_PASSWORD', 'REGISTRATION.CONTACT_NO',
      'REGISTRATION.VALIDATION_MSG.INVALID_PASSWORD', 'REGISTRATION.REENTER_PASSWORD', 'REGISTRATION.PASSWORDTEXT', 'REGISTRATION.VALIDATION_MSG.REQUIRED_CON_PASSWORD',
      'REGISTRATION.VALIDATION_MSG.INVALID_CONFORM_PASSWORD', 'REGISTRATION.PERINFO', 'REGISTRATION.FIRST_NAME', 'REGISTRATION.VALIDATION_MSG.REQUIRED_FIRST_NAME',
      'REGISTRATION.VALIDATION_MSG.INVALID_FIRST_NAME', 'REGISTRATION.LAST_NAME', 'REGISTRATION.VALIDATION_MSG.REQUIRED_LAST_NAME', 'REGISTRATION.VALIDATION_MSG.INVALID_LAST_NAME',
      'REGISTRATION.COUNTRY', 'REGISTRATION.VALIDATION_MSG.REQUIRED_COUNTRY_CODE', 'REGISTRATION.VALIDATION_MSG.INVALID_NUMBER', 'REGISTRATION.VALIDATION_MSG.WRONG_NUMBER',
      'REGISTRATION.VALIDATION_MSG.REQUIRED_CONTACTNO', 'REGISTRATION.DESIG', 'REGISTRATION.CAPTCHA', 'REGISTRATION.VALIDATION_MSG.REQUIRED_CAPTCHA', 'REGISTRATION.SUB_AGRMNT',
      'REGISTRATION.VALIDATION_MSG.REQUIRED_SUB_AGREE', 'REGISTRATION.REGISTER_USER_SERVER_MSG.INCOMPLETE_DATA', 'REGISTRATION.REGISTER_USER_SERVER_MSG.NETWORK_ERROR',
      'REGISTRATION.REGISTER_USER_SERVER_MSG.EMAIL_ALREADY_EXIST', 'REGISTRATION.REGISTER_USER_SERVER_MSG.USERNAME_ALREADY_EXIST', 'BUTTON_TITLE.SIGNUP',
      'REGISTRATION.REGISTER_USER_SERVER_MSG.INVALID_CAPTCHA', 'REGISTRATION.MODAL.TITLE_SUBSCRIPTION_AGREEMENT', 'REGISTRATION.ACCOUNTCREATEMSG',
      'REGISTRATION.VALIDATION_MSG.REQUIRED_COMMUNITY_ROLE']).subscribe(label => {
      this.buttonTitle = label;
      this.ngAfterViewInit();
    });
    this.route.params.subscribe(params => {
      let idflag = false;
      let urlflag = false;
      let id = '';
      let strUrl = '';
      if(params['id']){
        id = params['id'];
        if(id && id.includes('http')){
          this.redirectUrl = decodeURIComponent(id);
          idflag = true;
        }else{
          if(params['url']){
            strUrl = params['url'];
            if(strUrl && strUrl.includes('http')){
              this.redirectUrl = decodeURIComponent(strUrl);
              urlflag = true;
            }
          }
          this.community_id = id;
          if(this.community_id){
            this.userService.getCommunityByCommunityID(this.community_id).subscribe(community =>{
                if(community.success){
                  if(community.data){
                    let commResObj = {
                      community_id : community.data.comm_id,
                      community_name : community.data.comm_name,
                      resource_config : community.data.resource_config
                    };
                    localStorage.setItem('CommResources', JSON.stringify(commResObj));
                    let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;
                    let lang_name = defaultLangData.lang_name ? defaultLangData.lang_name : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');

                    this.translate.use(lang_name);
                    this.translate.reloadLang(lang_name);
                    this.translate.get(['REGISTRATION.COMM_ROLE','REGISTRATION.SELECT_ROLE', 'REGISTRATION.NONE',
                      'REGISTRATION.CREATEACCNTTEXT', 'REGISTRATION.GROUP', 'REGISTRATION.SELECT_GROUP', 'REGISTRATION.VALIDATION_MSG.REQUIRED_COMMUNITY',
                      'REGISTRATION.ORG', 'REGISTRATION.BUSINESS_UNIT', 'REGISTRATION.SELECT_B_UNIT', 'REGISTRATION.VALIDATION_MSG.REQUIRED_BUSINESS_UNIT', 'REGISTRATION.USER_ID',
                      'REGISTRATION.PLACEHOLDERS.USERNAME', 'REGISTRATION.USERNAME_NOTE', 'REGISTRATION.VALIDATION_MSG.REQUIRED_USERNAME', 'REGISTRATION.VALIDATION_MSG.INVALID_USERNAME',
                      'REGISTRATION.EMAIL_ID', 'REGISTRATION.VALIDATION_MSG.REQUIRED_EMAILID', 'REGISTRATION.VALIDATION_MSG.INVALID_EMAILID', 'REGISTRATION.SECURITY_QUESTION',
                      'SECURITY_QUESTION.DEFAULT_OPTION', 'REGISTRATION.VALIDATION_MSG.REQUIRED_SEC_QUE', 'BUTTON_TITLE.OK', 'REGISTRATION.COUNTRY_CODE', 'REGISTRATION.CLICK_HERE',
                      'REGISTRATION.SEC_QUE_ANS', 'REGISTRATION.PLACEHOLDERS.ANSWER', 'REGISTRATION.VALIDATION_MSG.REQUIRED_ANSWER', 'REGISTRATION.VALIDATION_MSG.INVALID_ANSWER',
                      'REGISTRATION.PASSWORD', 'REGISTRATION.PASSWORDTEXT', 'REGISTRATION.PASSWORD_NOTE', 'REGISTRATION.VALIDATION_MSG.REQUIRED_PASSWORD', 'REGISTRATION.CONTACT_NO',
                      'REGISTRATION.VALIDATION_MSG.INVALID_PASSWORD', 'REGISTRATION.REENTER_PASSWORD', 'REGISTRATION.PASSWORDTEXT', 'REGISTRATION.VALIDATION_MSG.REQUIRED_CON_PASSWORD',
                      'REGISTRATION.VALIDATION_MSG.INVALID_CONFORM_PASSWORD', 'REGISTRATION.PERINFO', 'REGISTRATION.FIRST_NAME', 'REGISTRATION.VALIDATION_MSG.REQUIRED_FIRST_NAME',
                      'REGISTRATION.VALIDATION_MSG.INVALID_FIRST_NAME', 'REGISTRATION.LAST_NAME', 'REGISTRATION.VALIDATION_MSG.REQUIRED_LAST_NAME', 'REGISTRATION.VALIDATION_MSG.INVALID_LAST_NAME',
                      'REGISTRATION.COUNTRY', 'REGISTRATION.VALIDATION_MSG.REQUIRED_COUNTRY_CODE', 'REGISTRATION.VALIDATION_MSG.INVALID_NUMBER', 'REGISTRATION.VALIDATION_MSG.WRONG_NUMBER',
                      'REGISTRATION.VALIDATION_MSG.REQUIRED_CONTACTNO', 'REGISTRATION.DESIG', 'REGISTRATION.CAPTCHA', 'REGISTRATION.VALIDATION_MSG.REQUIRED_CAPTCHA', 'REGISTRATION.SUB_AGRMNT',
                      'REGISTRATION.VALIDATION_MSG.REQUIRED_SUB_AGREE', 'REGISTRATION.REGISTER_USER_SERVER_MSG.INCOMPLETE_DATA', 'REGISTRATION.REGISTER_USER_SERVER_MSG.NETWORK_ERROR',
                      'REGISTRATION.REGISTER_USER_SERVER_MSG.EMAIL_ALREADY_EXIST', 'REGISTRATION.REGISTER_USER_SERVER_MSG.USERNAME_ALREADY_EXIST', 'BUTTON_TITLE.SIGNUP',
                      'REGISTRATION.REGISTER_USER_SERVER_MSG.INVALID_CAPTCHA', 'REGISTRATION.MODAL.TITLE_SUBSCRIPTION_AGREEMENT', 'REGISTRATION.ACCOUNTCREATEMSG',
                      'REGISTRATION.VALIDATION_MSG.REQUIRED_COMMUNITY_ROLE']).subscribe(label => {
                      this.buttonTitle = label;
                      this.ngAfterViewInit();
                      this.community_list.push(community.data);
                      if(community.data.privacy_protected){
                        this.privacyField = false;
                        this.privacyProtect=true;
                      } else {
                        this.privacyField = true;
                        this.privacyProtect=false;
                      }
                      this.userService.getCommunityLogo(this.community_id).subscribe(res =>{
                        let gObj = {
                          id: this.community_id,
                          communityID: this.community_id,
                          communityName: community.data.comm_name,
                          purpose: 'login',
                          image_data: res.data.image_data
                        };
                        this.globalService.isLoginComm = gObj;
                        let ob = {communityID: this.community_id};
                        this.userService.isCommunity = window.btoa(JSON.stringify(ob));
                        let commObj = {
                          communityID: this.community_id,
                          communityName: community.data.comm_name,
                          purpose: 'login'
                        };
                        this.getclientData(window.btoa(JSON.stringify(commObj)));
                      });
                    });
                  } else{
                    if(this.globalService.isLoginComm.communityID  != null && this.globalService.isLoginComm.communityID){
                      this.getCommunityResources(this.globalService.isLoginComm.communityID);
                      let comObj = {
                        communityName : this.globalService.isLoginComm.communityName,
                        communityID : this.globalService.isLoginComm.communityID,
                        purpose : "login"
                      };
                      let ob = {communityID : this.globalService.isLoginComm.communityID};
                      this.community_id = this.globalService.isLoginComm.communityID;
                      // this.isDisabledComm = true;
                      // this.isValidCommunity = true;
                      this.userService.isCommunity = window.btoa(JSON.stringify(ob));
                      this.getclientData(window.btoa(JSON.stringify(comObj)));
                    }else{
                      this.community_id = 'global';
                      this.getCommunityResources(this.community_id);
                      // this.isDisabledComm = false;
                      // this.isValidCommunity = true;
                      this.globalService.isLoginComm = {
                        id: null,
                        communityName : null,
                        communityID : null,
                        purpose : null,
                        image_data: null
                      };
                      this.userService.isCommunity = null;
                      this.getclientData(null);
                    }
                  }
                }else{
                  if(this.globalService.isLoginComm.communityID  != null && this.globalService.isLoginComm.communityID){
                    this.getCommunityResources(this.globalService.isLoginComm.communityID);
                    let comObj = {
                      communityName : this.globalService.isLoginComm.communityName,
                      communityID : this.globalService.isLoginComm.communityID,
                      purpose : "login"
                    };
                    let ob = {communityID : this.globalService.isLoginComm.communityID};
                    this.community_id = this.globalService.isLoginComm.communityID;
                    // this.isDisabledComm = true;
                    // this.isValidCommunity = true;
                    this.userService.isCommunity = window.btoa(JSON.stringify(ob));
                    this.getclientData(window.btoa(JSON.stringify(comObj)));
                  }else{
                    this.community_id = 'global';
                    this.getCommunityResources(this.community_id);
                    // this.isDisabledComm = false;
                    // this.isValidCommunity = true;
                    this.globalService.isLoginComm = {
                      id: null,
                      communityName : null,
                      communityID : null,
                      purpose : null,
                      image_data: null
                    };
                    this.userService.isCommunity = null;
                    this.getclientData(null);
                  }
                }
              });
          }else{
            if(this.globalService.isLoginComm.communityID  != null && this.globalService.isLoginComm.communityID){
              this.getCommunityResources(this.globalService.isLoginComm.communityID);
              let comObj = {
                communityName : this.globalService.isLoginComm.communityName,
                communityID : this.globalService.isLoginComm.communityID,
                purpose : "login"
              };
              let ob = {communityID : this.globalService.isLoginComm.communityID};
              this.community_id = this.globalService.isLoginComm.communityID;
              // this.isDisabledComm = true;
              // this.isValidCommunity = true;
              this.userService.isCommunity = window.btoa(JSON.stringify(ob));
              this.getclientData(window.btoa(JSON.stringify(comObj)));
            }else{
              this.community_id = 'global';
              this.getCommunityResources(this.community_id);
              // this.isDisabledComm = false;
              // this.isValidCommunity = true;
              this.globalService.isLoginComm = {
                id: null,
                communityName : null,
                communityID : null,
                purpose : null,
                image_data: null
              };
              this.userService.isCommunity = null;
              this.getclientData(null);
            }
          }
        }
      }

      if(idflag || !(params['id'])){
        if(this.globalService.isLoginComm.communityID  != null && this.globalService.isLoginComm.communityID){
          let comObj = {
            communityName : this.globalService.isLoginComm.communityName,
            communityID : this.globalService.isLoginComm.communityID,
            purpose : "login"
          };
          let ob = {communityID : this.globalService.isLoginComm.communityID};
          this.community_id = this.globalService.isLoginComm.communityID;
          // this.isDisabledComm = true;
          // this.isValidCommunity = true;
          this.userService.isCommunity = window.btoa(JSON.stringify(ob));
          this.getclientData(window.btoa(JSON.stringify(comObj)));
        }else{
          this.community_id = 'global';
          this.getCommunityResources(this.community_id);
          // this.isDisabledComm = false;
          // this.isValidCommunity = true;
          this.globalService.isLoginComm = {
            id: null,
            communityName : null,
            communityID : null,
            purpose : null,
            image_data: null
          };
          this.userService.isCommunity = null;
          this.getclientData(null);
        }
      }
    });
  }

  changePasswordType() {
    this.passwordType = !this.passwordType
  }

  getclientData(id: any){
    this.userService.getClientData(id).subscribe(result => {
      if (result == '' || result == null) {
        $("#preloader").css('display','none');
      } else {
        localStorage.setItem('CompanyData', JSON.stringify(result.data));

        this.userService.getAllCommunities().subscribe(community =>{
          if(community.success){
            this.community_list = community.data;
            if(this.community_id){
            } else {
              this.community_id = 'global';
            }
            let val = this.community_list.findIndex(comm=> comm.comm_id == this.community_id);
            if(val > -1){
              this.community_id = this.community_list[val].comm_id;
              if(this.community_id != 'global'){
                // this.isValidCommunity = false;
                if(this.community_list[val].privacy_protected){
                  this.privacyField = false;
                } else {
                  this.privacyField = true;
                }
              }else{
                // this.isValidCommunity = true;
              }
              this.userService.getOrganizationName(this.community_list[val].organization_id).subscribe(res =>{
                if(res.success){
                  this.organization = res.data;
                  this.selectedOrganization = true;
                  this.getAllRoleBUnit();
                  $("#preloader").css('display','none');
                }
              });
            }
          }else{
            $("#preloader").css('display','none');
          }
        });
      }
    });
  }


  getCommList(){
    this.userService.getAllCommunities()
      .subscribe(community =>{
        if(community.success){
          this.community_list = community.data;
          let val = this.community_list.findIndex(comm=> comm.comm_id == 'global');
          if(val > -1){
            this.community_id = this.community_list[val].comm_id;
            this.userService.getOrganizationName(this.community_list[val].organization_id).subscribe(res =>{
              if(res.success){
                this.organization = res.data;
                this.selectedOrganization = true;
                this.comm_role = undefined;
                this.business_unit = undefined;
                this.getAllRoleBUnit();
              }
            });
          }
        }
      });
  }

  addNewUser(newUserForm) {

    if(this.errorMsg == ""){
      if(this.captcha == this.reCaptcha){
        let defaultLang = this.cookieService.get('defaultLang');
        if(!defaultLang){
          defaultLang = 'English';
        }
        const theCommunity = JSON.parse(localStorage.getItem('CompanyData'));
        let communityID;
        let community_id;
        let fname;
        let lname;
        let designation;
        let phone;
        let mailid;

        if(theCommunity){
          communityID = theCommunity.communityID;
        }
        if(this.privacyProtect){
          fname = "";
          lname = "";
          designation = "";
          phone = "";
          mailid = "";
        }else {
          fname = this.first_name;
          lname = this.last_name;
          designation = this.designation;
          phone = this.contact;
          mailid = this.mail_id.toLowerCase();
        }
        if(this.community_id){
          community_id = this.community_id;

        } else {
          if(communityID != "alignorComm"){
            community_id = communityID;
          } else {
            community_id = "global";
          }
        }

        const newUser = {
          user_name : this.user_name,
          first_name: fname,
          last_name: lname,
          mail_id: mailid,
          phone: phone,
          question: this.question,
          answer: this.answer,
          password: this.password,
          re_password: this.re_password,
          organization: this.organization,
          designation: designation,
          privacyProtect: this.privacyProtect,
          role : 'Learner',
          defaultLang : defaultLang,
          community_id : community_id,
          community_user : this.community_user,
          is_deleted : false,
          bulk_registration: false,
          created_by : "System",
          country : this.country,
          language_id : this.globalService.getLangId(),
          business_unit: this.business_unit,
          comm_role: this.comm_role
        };

        this.userService.registerUser(newUser).subscribe(user => {
          this.statusCode = user.statusCode;
          if(user.success){
            newUserForm.reset();
            this.countryCode = undefined;
            this.countryId = undefined;
            this.contact = "";
            $('#successModal').modal('show');
            // this.router.navigate(['/login']);
          }
        });
      } else {
        this.statusCode = '203';
        this.changeCaptcha(newUserForm);
      }
    }

  }

  changeCaptcha(newUserForm){
    const c = this.captchaCanvas.nativeElement;
    let ctx = c.getContext("2d");
    ctx.clearRect(0, 0, c.width, c.height);
    this.captcha = Math.random().toString(36).split('').filter( function(value, index, self) {
      return self.indexOf(value) === index;
    }).join('').substr(2,6);
    this.ngAfterViewInit();
    this.reCaptcha = "";
    newUserForm.form.controls.cap.reset();
  }

  ngAfterViewInit() {
    if(this.captchaCanvas){
      setTimeout(()=>{
        const c = this.captchaCanvas.nativeElement;
        let ctx = c.getContext('2d');
        ctx.font='oblique 35px Comic Sans MS';
        ctx.textBaseline="alphabetic";
        ctx.fillText(this.captcha, 190, 45);
      }, 200);
    }
  }

  changeEmailFlag(e) {
    this.userService.getCommunityByCommunityID(this.community_id)
      .subscribe(community => {
        if (community.success) {
          if(community.data.privacy_protected){
            //$('#email').val('abc@gmail.com');
            this.privacyField = false;
            this.privacyProtect=true;
          } else {
            this.privacyField = true;
            this.privacyProtect=false;
          }
          this.userService.getOrganizationName(community.data.organization_id).subscribe(res =>{
            if(res.success){
              this.organization = res.data;
              this.selectedOrganization = true;
            }
          });
          this.comm_role = undefined;
          this.business_unit = undefined;
          this.getAllRoleBUnit();
        }
      });
  }

  checkValidNumber(e){
    let str  = e.target.value.trim();
    let res : boolean = false;

    if(str){
      let newSupRegex = new RegExp("\\.");
      let validTxt = newSupRegex.test(str);

      if(!validTxt) {
        if (!isNaN(str.replace(/[^a-zA-Z]/g, ""))) {
          if (str.length > 5 && str.length < 18) {
            try {
              const newStr: string = this.countryCode + str;
              this.parse = parse(newStr);
              // Print number in the international format
              res = isValidNumber(this.parse);
              let num = formatNumber(newStr, 'International');
              this.contact = num.trim();
            } catch (error) {
              this.errorMsg = "202";
            }
          } else if (str.length == 0) {
            res = true;
          }
        }
      } else {
        this.errorMsg = "202";
      }

      if(!res) {
        this.errorMsg = "203";
      } else {
        /*if(str.length > 0){
          this.errorMsg = "";
        } else {
          this.errorMsg = "205";
        }*/
        this.errorMsg = "";
      }
    } else {
      this.errorMsg = '';
    }
  }

  changeCountry(e){
    this.phone = "";
    this.contact = "";
    if(this.countryId){
      let ind = this.countryCodeList.findIndex(c=> c.iso2 == this.countryId);
      if(ind > -1){
        this.country = this.countryCodeList[ind].name;
        this.countryCode = this.countryCodeList[ind].code;
      }else{
        this.country = undefined;
        this.countryCode = undefined;
      }
      // this.errorMsg = "205";
      this.errorMsg = "";
    } else {
      this.country = "";
      this.errorMsg = "";
      this.phone = "";
    }
  }

  clearServerValidation(){
    this.statusCode = "";
  }

  closeSuccessModal(){
    $('#successModal').modal('hide');
    if(this.redirectUrl != ''){
      location.replace(this.redirectUrl);
    }else{
      this.router.navigate(['/isolatedLogin']);
      // window.close();
    }
  }

  follwRules(){
    if(this.community_id == 'global'){
      this.businessUnitList = []; // JSON.parse(JSON.stringify(this.businessUnitList));
      this.business_unit = 'None';
      this.isDisableBUnit = true;
    }else{
      if(this.businessUnitList && this.businessUnitList.length > 0){
        if(this.businessUnitList.length == 1){
          this.isDisableBUnit = true;
          this.business_unit = this.businessUnitList[0];
        }else{
          this.isDisableBUnit = false;
        }
      } else{
        this.business_unit = 'None';
        this.isDisableBUnit = true;
      }
    }

    if(this.communityRoleList && this.communityRoleList.length > 0){
      //For CommRole
      if(this.communityRoleList.length == 1){
        this.isDisableCommRole = true;
        this.comm_role = this.communityRoleList[0];
      }else{
        this.isDisableCommRole = false;
      }
    } else{
      this.comm_role = 'None';
      this.isDisableCommRole = true;
    }
  }
  getAllRoleBUnit(){
    this.userService.getRoleAndBusinessUnitById(this.community_id).subscribe(rb =>{
      if(rb.success){
        if(rb.data && rb.data.length > 0){
          let resArr = rb.data;
          let ind = resArr.findIndex(r=> r.comm_id == 'global');
          if(ind > -1){
            this.globalCommRoleList = resArr[ind].comm_role && resArr[ind].comm_role.length > 0 ? resArr[ind].comm_role : [];
            this.globalBUnitList = resArr[ind].business_unit && resArr[ind].business_unit.length > 0 ? resArr[ind].business_unit : [];
            resArr.splice(ind,1);
            if(resArr && resArr.length > 0){
              this.communityRoleList = resArr[0].comm_role && resArr[0].comm_role.length > 0 ? resArr[0].comm_role : this.globalCommRoleList;
              this.businessUnitList = resArr[0].business_unit && resArr[0].business_unit.length > 0 ? resArr[0].business_unit : [];
            }else{
              this.communityRoleList = (this.globalCommRoleList && this.globalCommRoleList.length > 0) ? JSON.parse(JSON.stringify(this.globalCommRoleList)) : [];
              this.businessUnitList = []; // JSON.parse(JSON.stringify(this.globalBUnitList));
            }
          }else{
            this.globalCommRoleList = [];
            this.globalBUnitList = [];
            let cind = resArr.findIndex(r=> r.comm_id == this.community_id);
            if(cind > -1){
              this.communityRoleList = resArr[cind].comm_role && resArr[cind].comm_role.length > 0 ? resArr[cind].comm_role : [];
              this.businessUnitList = resArr[cind].business_unit && resArr[cind].business_unit.length > 0 ? resArr[cind].business_unit : [];
            }else{
              this.communityRoleList = [];
              this.businessUnitList = [];
            }
          }
          this.follwRules();
        }

      }
    });
  }

  showLogo(){
    console.log(this.globalService.isLoginComm);
    if(this.globalService.isLoginComm.communityID  != null  && this.globalService.isLoginComm != null){
      this.communityLogoShow = true;
      this.community_name = this.globalService.isLoginComm.communityName;
      $("#compLogoImg").attr('src', "data:image/png;base64, " + this.globalService.isLoginComm.image_data);
      return false;
    }else{
      this.communityLogoShow = false;
      this.community_name = '';
      return true;
    }
  }

  isDisabledComm(){
    const theCommunity = JSON.parse(localStorage.getItem('CompanyData'));
    if(theCommunity && theCommunity.communityID && theCommunity.communityID == 'global'){
      return false;
    }else{
      return true;
    }
  }

  getCommunityResources(id){
    $("#preloader").css('display','block');
    if(id && id.length > 0){
      this.userService.getResourceConfiguration(id).subscribe(res=>{
        if(res.success){
          let commResObj = {
            community_id : res.data.comm_id,
            community_name : res.data.comm_name,
            resource_config : res.data.resource_config
          };
          localStorage.setItem('CommResources', JSON.stringify(commResObj));

          let lang_name = this.cookieService.get('defaultLang') ? this.cookieService.get('defaultLang') : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');
          console.log(".........Done ", lang_name);
          this.translate.reloadLang(lang_name);
          this.translate.get(['REGISTRATION.COMM_ROLE','REGISTRATION.SELECT_ROLE', 'REGISTRATION.NONE',
            'REGISTRATION.CREATEACCNTTEXT', 'REGISTRATION.GROUP', 'REGISTRATION.SELECT_GROUP', 'REGISTRATION.VALIDATION_MSG.REQUIRED_COMMUNITY',
            'REGISTRATION.ORG', 'REGISTRATION.BUSINESS_UNIT', 'REGISTRATION.SELECT_B_UNIT', 'REGISTRATION.VALIDATION_MSG.REQUIRED_BUSINESS_UNIT', 'REGISTRATION.USER_ID',
            'REGISTRATION.PLACEHOLDERS.USERNAME', 'REGISTRATION.USERNAME_NOTE', 'REGISTRATION.VALIDATION_MSG.REQUIRED_USERNAME', 'REGISTRATION.VALIDATION_MSG.INVALID_USERNAME',
            'REGISTRATION.EMAIL_ID', 'REGISTRATION.VALIDATION_MSG.REQUIRED_EMAILID', 'REGISTRATION.VALIDATION_MSG.INVALID_EMAILID', 'REGISTRATION.SECURITY_QUESTION',
            'SECURITY_QUESTION.DEFAULT_OPTION', 'REGISTRATION.VALIDATION_MSG.REQUIRED_SEC_QUE', 'BUTTON_TITLE.OK', 'REGISTRATION.COUNTRY_CODE', 'REGISTRATION.CLICK_HERE',
            'REGISTRATION.SEC_QUE_ANS', 'REGISTRATION.PLACEHOLDERS.ANSWER', 'REGISTRATION.VALIDATION_MSG.REQUIRED_ANSWER', 'REGISTRATION.VALIDATION_MSG.INVALID_ANSWER',
            'REGISTRATION.PASSWORD', 'REGISTRATION.PASSWORDTEXT', 'REGISTRATION.PASSWORD_NOTE', 'REGISTRATION.VALIDATION_MSG.REQUIRED_PASSWORD', 'REGISTRATION.CONTACT_NO',
            'REGISTRATION.VALIDATION_MSG.INVALID_PASSWORD', 'REGISTRATION.REENTER_PASSWORD', 'REGISTRATION.PASSWORDTEXT', 'REGISTRATION.VALIDATION_MSG.REQUIRED_CON_PASSWORD',
            'REGISTRATION.VALIDATION_MSG.INVALID_CONFORM_PASSWORD', 'REGISTRATION.PERINFO', 'REGISTRATION.FIRST_NAME', 'REGISTRATION.VALIDATION_MSG.REQUIRED_FIRST_NAME',
            'REGISTRATION.VALIDATION_MSG.INVALID_FIRST_NAME', 'REGISTRATION.LAST_NAME', 'REGISTRATION.VALIDATION_MSG.REQUIRED_LAST_NAME', 'REGISTRATION.VALIDATION_MSG.INVALID_LAST_NAME',
            'REGISTRATION.COUNTRY', 'REGISTRATION.VALIDATION_MSG.REQUIRED_COUNTRY_CODE', 'REGISTRATION.VALIDATION_MSG.INVALID_NUMBER', 'REGISTRATION.VALIDATION_MSG.WRONG_NUMBER',
            'REGISTRATION.VALIDATION_MSG.REQUIRED_CONTACTNO', 'REGISTRATION.DESIG', 'REGISTRATION.CAPTCHA', 'REGISTRATION.VALIDATION_MSG.REQUIRED_CAPTCHA', 'REGISTRATION.SUB_AGRMNT',
            'REGISTRATION.VALIDATION_MSG.REQUIRED_SUB_AGREE', 'REGISTRATION.REGISTER_USER_SERVER_MSG.INCOMPLETE_DATA', 'REGISTRATION.REGISTER_USER_SERVER_MSG.NETWORK_ERROR',
            'REGISTRATION.REGISTER_USER_SERVER_MSG.EMAIL_ALREADY_EXIST', 'REGISTRATION.REGISTER_USER_SERVER_MSG.USERNAME_ALREADY_EXIST', 'BUTTON_TITLE.SIGNUP',
            'REGISTRATION.REGISTER_USER_SERVER_MSG.INVALID_CAPTCHA', 'REGISTRATION.MODAL.TITLE_SUBSCRIPTION_AGREEMENT', 'REGISTRATION.ACCOUNTCREATEMSG',
            'REGISTRATION.VALIDATION_MSG.REQUIRED_COMMUNITY_ROLE']).subscribe(label => {
            this.buttonTitle = label;
            this.ngAfterViewInit();
            $("#preloader").css('display','none');
          });
        }else{
          $("#preloader").css('display','none');
        }
      });
    }else{
      $("#preloader").css('display','none');
    }
  }
  ngOnDestroy(){
    $("body").removeClass("isolatedBg");
  }
}



// WEBPACK FOOTER //
// ./src/app/Screens/isolated-new-user/isolated-new-user.component.ts